export enum PageTab {
  Templates = 'templates',
  Active = 'mine',
  Archived = 'archived'
}
